export default __webpack_public_path__ + "static/ranklists-processing-fe7145b567967ac4f401c314cd823569.gif";